import React from 'react';
import { Redirect } from 'react-router-dom';
import routes from '../routes';
import { useEngineer } from './EngineerProvider';
import LoadingPage from './Loading/Page';

export default function Home() {
  const { engineer, fetching } = useEngineer();
  if (fetching) return <LoadingPage />;
  return <Redirect to={engineer ? routes.jobs.root : routes.welcome.root} />;
}
